import * as React from "react";

const SvgComponent = (props) => (
    <svg width="16" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.651 1.32178L5.31771 8.65511L1.98438 5.32178" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

);

export default SvgComponent;